import { render, staticRenderFns } from "./NewSmartLessonPage.vue?vue&type=template&id=796b7868&lang=pug&"
import script from "./NewSmartLessonPage.vue?vue&type=script&lang=js&"
export * from "./NewSmartLessonPage.vue?vue&type=script&lang=js&"
import style0 from "./NewSmartLessonPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports